
/**
 * ColotUtils
 * (c) lg2fabrique 2017
 *
 */

export default class ColorUtils {

    /**
     * Get a random for a particular range
     * @param {Number} min Minimum number
     * @param {Number} max Maximum number
     * @param {Boolean} [rounded=true] Makes sure the result will be an integer
     *
     * @return {Number}
     *   ColotUtils.random(2, 10);
     */
    public static rgb2hex(color: string) {
        let rgb = color.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i );
        return (rgb && rgb.length === 4) ? '0x'+
        ("0" + parseInt(rgb[1],10).toString(16)).slice(-2) +
        ("0" + parseInt(rgb[2],10).toString(16)).slice(-2) +
        ("0" + parseInt(rgb[3],10).toString(16)).slice(-2) : '';
    };


}